import type { State } from './state';

export type Getters = {
    user(state: State): State['user'];
};

export const getters: Getters = {
    user: (state) => state.user,
};
